import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import FilterWrap from 'components/atoms/FilterWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

import FreqStatisticsGraph from './FreqStatisticsGraph';

let initialization = false;
let initParam = {
  type: '01',
};
const FreqStatistics = ({ location }) => {
  // 키워드센터 - 광고주별수집현황 : adverId
  const { adverId } = queryString.parse(location.search);
  if (typeof adverId !== 'undefined') initParam.adverId = adverId;

  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);
  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);

    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          noneExternalFilter={true}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <FreqStatisticsGraph params={{ ...params }} />
        </>
      )}
    </>
  );
};

export default withRouter(FreqStatistics);
